// components/ProductSelection/ProductSearchInterface.jsx
import React from "react";
import {
  SearchIcon,
  XIcon,
  LightBulbIcon,
  PlusCircleIcon,
} from "@heroicons/react/outline";

const ProductSearchInterface = ({
  searchQuery,
  searchSuggestion,
  isSearching,
  onSearchChange,
  onCreateProduct,
  allowCreate,
}) => {
  return (
    <div className="space-y-4">
      {/* Search Input */}
      <div className="relative">
        <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
        <input
          type="text"
          placeholder="Search by name, product ID, karigar code, or HUID..."
          value={searchQuery}
          onChange={onSearchChange}
          className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-base"
          autoFocus
        />
        {searchQuery && (
          <button
            onClick={() => onSearchChange({ target: { value: "" } })}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <XIcon className="w-5 h-5" />
          </button>
        )}
      </div>

      {/* Smart Suggestion */}
      {searchSuggestion && searchQuery && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <div className="flex items-start gap-2">
            <LightBulbIcon className="w-5 h-5 text-blue-600 mt-0.5" />
            <div className="flex-1">
              <p className="text-sm text-blue-800">
                {searchSuggestion.type === "productId" &&
                  `Detected Product ID: ${searchSuggestion.fields.productId}`}
                {searchSuggestion.type === "karigarCode" &&
                  `Detected Karigar Code: ${searchSuggestion.fields.karigarCode}`}
                {searchSuggestion.type === "huid" &&
                  `Detected HUID: ${searchSuggestion.fields["hallmark.huid"]}`}
                {searchSuggestion.type === "name" &&
                  `Searching for: ${searchSuggestion.fields.name}`}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Quick Actions */}
      {!searchQuery && allowCreate && (
        <button
          onClick={onCreateProduct}
          className="w-full p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-primary hover:bg-gray-50 transition-all group"
        >
          <div className="flex items-center justify-center gap-3">
            <PlusCircleIcon className="w-6 h-6 text-gray-400 group-hover:text-primary" />
            <span className="text-gray-600 group-hover:text-primary font-medium">
              Create New Product
            </span>
          </div>
        </button>
      )}

      {/* Loading State */}
      {isSearching && (
        <div className="text-center py-8">
          <div className="inline-flex items-center gap-2 text-gray-600">
            <svg
              className="animate-spin h-5 w-5 text-primary"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
                fill="none"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              />
            </svg>
            <span>Searching products...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductSearchInterface;
